import React, { ReactNode } from 'react';
import { ErrorBoundary } from './ErrorBoundary';
import { NetworkErrorBoundary } from './NetworkErrorBoundary';
import { CSSLoadingErrorBoundary } from './CSSLoadingErrorBoundary';

interface Props {
  children: ReactNode;
  level?: 'root' | 'page' | 'component';
  enableRetry?: boolean;
  showContactSupport?: boolean;
  onRetry?: () => void;
}

export function ComprehensiveErrorBoundary({
  children,
  level = 'component',
  enableRetry = true,
  showContactSupport = false,
  onRetry
}: Props) {
  return (
    <ErrorBoundary 
      level={level} 
      enableRetry={enableRetry} 
      showContactSupport={showContactSupport}
    >
      <NetworkErrorBoundary onRetry={onRetry}>
        <CSSLoadingErrorBoundary>
          {children}
        </CSSLoadingErrorBoundary>
      </NetworkErrorBoundary>
    </ErrorBoundary>
  );
}